export default __webpack_public_path__ + "static/media/shop-06.9a3054b6.png";